import type { ThemeSchemaResponse } from '@api/api/theme-overview';
import { useThemeCompanies } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { getMSProxyThemeIds } from '../utils/msBasketSentiment';

export type SentimentScope =
  | {
      kind: 'theme';
      themeIds: string[];
      companyIds: undefined;
      isReady: true;
      isLoading: false;
      isError: false;
    }
  | {
      kind: 'basket';
      themeIds: string[];
      companyIds: string[];
      isReady: boolean;
      isLoading: boolean;
      isError: boolean;
    };

export const useSentimentScope = (theme: ThemeSchemaResponse) => {
  const isMsPulseEnabled = useFlags(state =>
    state.getFeatureFlagState('KG-1160-ms-pulse')
  );
  const isMSBasket = isMsPulseEnabled && !!theme.metadata?.ms_basket_ticker;
  const companies = useThemeCompanies({
    themeId: theme.id,
    enabled: isMSBasket,
  });

  if (!isMSBasket) {
    return {
      kind: 'theme',
      themeIds: [theme.id],
      companyIds: undefined,
      isReady: true,
      isLoading: false,
      isError: false,
    } satisfies SentimentScope;
  }

  return {
    kind: 'basket',
    themeIds: getMSProxyThemeIds(theme),
    companyIds: companies.data?.map(company => company.company) ?? [],
    isReady: companies.data !== undefined,
    isLoading: companies.isLoading,
    isError: companies.isError,
  } satisfies SentimentScope;
};
